import { Component, OnInit } from '@angular/core';
import Map from "@arcgis/core/Map";
import MapView from '@arcgis/core/views/MapView';
import { MapService } from 'src/app/view/services/map.service';
import * as promiseUtils from "@arcgis/core/core/promiseUtils";
import Graphic from "@arcgis/core/Graphic";
import * as reactiveUtils from "@arcgis/core/core/reactiveUtils";

@Component({
  selector: 'app-overview-map',
  templateUrl: './overview-map.component.html',
  styleUrls: ['./overview-map.component.css']
})
export class OverviewMapComponent implements OnInit {
  view: any;
  mainView: any;

  constructor(
    public mapService: MapService
  ) { }

  ngOnInit(): void {
    this.createOveriew().then(() => {
      this.setUp()
    })
  }

  createOveriew() {
    const overviewMap = new Map({
      basemap: "topo-vector"
    });

    // esta es la vista del mapa overview
    this.view = new MapView({
      container: 'overviewDiv',
      map: overviewMap,
      constraints: {
        rotationEnabled: false
      }
    });

    // esta es la vista del mapa principal
    this.mainView = this.mapService.getViewMap()

    this.view.ui.components = [];

    return this.view.when()
  }

  setUp() {
    const extentDebouncer = promiseUtils.debounce(() => {
      this.view.goTo({
        center: this.mainView.center,
        scale: this.mainView.scale * 2.2 *
          Math.max(
            this.mainView.width / this.view.width,
            this.mainView.height / this.view.height
          )
      });
      return this.view.when()
    });

    const extentGraphic = new Graphic({
      geometry: null,
      symbol: {
        // @ts-ignore
        type: "simple-fill",
        color: [0, 0, 0, 0.5],
        outline: null
      }
    });

    this.view.graphics.add(extentGraphic);

    reactiveUtils.watch(() => [this.mainView.stationary, this.mainView.extent], ([stationary, extent]) => {
      if (stationary) {
        extentDebouncer().then(() => {
          extentGraphic.geometry = extent;
        });
      }
    },
      { initial: true }
    )
  }
}
